export default __webpack_public_path__ + "guide-access-elevation-data-example-response-960-5d3c885c50fbb3feea782f36bf241b87.png";